import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { SvgAppIcons } from '../icons/app/index.es.js';
import { SvgBlockchainIcons } from '../icons/blockchain/index.es.js';
import { SvgCommonIcons } from '../icons/common/index.es.js';
import { SvgExchangeIcons } from '../icons/exchange/index.es.js';
import { SvgFlagIcons } from '../icons/flag/index.es.js';
import { SvgMiscellaneousIcons } from '../icons/miscellaneous/index.es.js';
import { SvgPaymentIcons } from '../icons/payment/index.es.js';
import { SvgSocialIcons } from '../icons/social/index.es.js';
import { SvgStablecoinIcons } from '../icons/stablecoin/index.es.js';
import { SvgTokenIcons } from '../icons/token/index.es.js';
import { SvgWalletIcons } from '../icons/wallet/index.es.js';
import { IconNameAliases } from '../icons/aliases.es.js';

/**
 * Compose Icon List.
 */ const SvgIconsList = {
    ...SvgAppIcons,
    ...SvgBlockchainIcons,
    ...SvgCommonIcons,
    ...SvgExchangeIcons,
    ...SvgPaymentIcons,
    ...SvgMiscellaneousIcons,
    ...SvgSocialIcons,
    ...SvgFlagIcons,
    ...SvgStablecoinIcons,
    ...SvgTokenIcons,
    ...SvgWalletIcons,
    ...IconNameAliases
};
const IconCore = ({ name, className, size = 16, disabled, ...props })=>{
    const iconName = name.toLowerCase();
    // Pick the icon as a component
    const SvgIcon = useMemo(()=>SvgIconsList[name], [
        name
    ]);
    // Combine class names
    const classes = classNames('cb-icon', `cb-icon-${iconName}`, className, {
        'cursor-pointer': props.onClick,
        'pointer-events-none': !props.onClick || disabled
    });
    return jsx(SvgIcon, {
        className: classes,
        height: size,
        width: size,
        ...props,
        "aria-hidden": !props.onClick,
        "data-testid": `icon-${iconName}`,
        focusable: false,
        role: "img"
    });
};
IconCore.displayName = 'Icon.Core';

export { IconCore, IconCore as default };
//# sourceMappingURL=Icon.Core.es.js.map
